/**
 * Interactive crossword grid on hints pages (markup: Grid_Renderer::render()).
 *
 * Clicking a square reveals its letter and clicking again hides it, the same toggle the per-answer
 * letter reveal on this page uses. Reveal Grid fills every square; Hide Grid clears them. The
 * letters come from the JSON block beside the board, indexed like the squares' data-i.
 */
function initGrid( root ) {

    const dataEl = root.querySelector( '.crossword-grid__data' );
    const board  = root.querySelector( '.crossword-grid__board' );

    if ( ! dataEl || ! board ) {
        return;
    }

    let cells;

    try {
        cells = JSON.parse( dataEl.textContent ).cells || [];
    } catch ( e ) {
        return;
    }

    const squares    = Array.from( board.querySelectorAll( '.cw-cell[data-i]' ) );
    const revealBtn  = root.querySelector( '[data-action="reveal-all"]' );
    const hideBtn    = root.querySelector( '[data-action="hide-all"]' );

    function setRevealed( square, revealed ) {

        const letter = cells[ Number( square.dataset.i ) ] || '';

        square.querySelector( '.cw-letter' ).textContent = revealed ? letter : '';
        square.classList.toggle( 'is-revealed', revealed );
        square.setAttribute(
            'aria-label',
            square.dataset.label + ( revealed ? ` Letter ${ letter }.` : ' Hidden.' )
        );
    }

    // Keep the buttons honest when squares are revealed one at a time.
    function syncButtons() {

        const allRevealed = squares.every( ( square ) => square.classList.contains( 'is-revealed' ) );

        if ( revealBtn ) {
            revealBtn.hidden = allRevealed;
        }

        if ( hideBtn ) {
            hideBtn.hidden = ! squares.some( ( square ) => square.classList.contains( 'is-revealed' ) );
        }
    }

    board.addEventListener( 'click', ( e ) => {

        const square = e.target.closest( '.cw-cell[data-i]' );

        if ( ! square ) {
            return;
        }

        setRevealed( square, ! square.classList.contains( 'is-revealed' ) );
        syncButtons();
    } );

    root.addEventListener( 'click', ( e ) => {

        const button = e.target.closest( '[data-action]' );

        if ( ! button ) {
            return;
        }

        const reveal = button.dataset.action === 'reveal-all';

        squares.forEach( ( square ) => setRevealed( square, reveal ) );
        syncButtons();
    } );
}

document.querySelectorAll( '[data-crossword-grid]' ).forEach( initGrid );
